<template>
  <div class="attract animate__animated" id="sqshow">
    <div class="attract_box maxWidth">
      <div class="attract-top">
        <div>授权展示</div>
        <div></div>
      </div>
      <div class="attract-center" id="viewerBox">
        <div
          @mousemove="attractMous(index)"
          @click="lookAttract(index)"
          v-for="(item, index) in attractList"
          :key="index"
        >
          <div class="img">
            <img
              :data-original="item.url"
              :src="item.url"
            />
            <!-- <img v-else :src="item.url" /> -->
            <div v-if="item.show" class="attract_shadow_img"></div>
          </div>

          <div v-if="item.show" class="attract_magnify"></div>
          <div v-if="item.show" class="attract_shadow"></div>
        </div>
      </div>
      <!-- 无权限提示 -->
      <transition enter-active-class="animate__animated animate__fadeInDown">
        <div v-if="jurisdiction" class="jurisdiction">暂无权限打开</div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jurisdiction: false,
      pcViewer: null, //图片预览实例
      antishake: "",
      attractList: [
        {
          url: require("../../assets/images/accredit.jpg"),
          show: true,
          background:
            "url('../../assets/images/accredit.jpg') no-repeat center",
        },
        {
          url: require("../../assets/images/1.png"),
          show: false,
          background: "url('../../assets/images/1.png') no-repeat center",
        },
        {
          url: require("../../assets/images/2.png"),
          show: false,
          background: "url('../../assets/images/2.png') no-repeat center",
        },
        {
          url: require("../../assets/images/3.jpg"),
          show: false,
          background: "url('../../assets/images/3.jpg') no-repeat center",
        },
        // {
        // 	url: "./images/4.png",
        // 	show: false,
        // 	background: "url('./images/4.png') no-repeat center"

        // }
      ],
    };
  },
  created() {},
  mounted() {
    this.antishake = this.debounce(this.lookAttractF);
    this.$nextTick(() => {
      this.viewerInit();
    });
  },
  methods: {
    // 初始化图片预览
    viewerInit() {
      let viewerBox = document.querySelector("#viewerBox");
      this.pcViewer = new Viewer(viewerBox, {
        url: "data-original",
        toolbar: true,
        movable: true,
        title: false,
      });
    },

    debounce(fun, wait = 1000) {
      let timeout = null;
      return function () {
        if (timeout) {
          //如果存在定时器就清空
          clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
          fun.apply(this, arguments);
        }, wait);
      };
    },

    attractMous(index) {
      this.attractList.forEach(item => {
						item.show = false
					})
					this.attractList[index].show = true
      // if (index == 0) {
      //   this.attractList[index].show = true;
      // }
    },
    lookAttract(index) {
      this.pcViewer.index = index
					this.pcViewer.show()
      // if (index == 0) {
      //   this.pcViewer.index = index;
      //   this.pcViewer.show();
      // } else {
      //   this.jurisdiction = true;
      //   this.antishake();
      // }
    },
    lookAttractF() {
      setTimeout(() => {
        this.jurisdiction = false;
      }, 1000);
    },
  },
};
</script>

<style scoped lang="scss">
.jurisdiction {
  position: fixed;
  top: 1.25rem /* 100/80 */;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 99999999;
  padding: 0.25rem /* 20/80 */;
  border-radius: 0.125rem /* 10/80 */;
  color: #000;
  background: #fff;
  font-size: 0.2rem /* 16/80 */;
  width: 2.5rem /* 200/80 */;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0.05rem /* 4/80 */ 0.15rem /* 12/80 */;
}
.attract {
  width: 100%;
  height: 9.6625rem /* 773/80 */;
  background: #3a3a38;
}
.attract_box {
  height: 100%;
  background: url("../../assets/images/attract_investment.jpg") no-repeat center;
  background-size: cover;
}
.attract-top > div:nth-child(1) {
  font-size: 0.45rem /* 36/80 */;
  color: #fff;
  padding-top: 0.775rem /* 62/80 */;
  margin-bottom: 0.3125rem /* 25/80 */;
  font-weight: 700;
  text-align: center;
}

.attract-top > div:nth-child(2) {
  width: 10.875rem /* 870/80 */;
  height: 1px;
  margin: 0 auto;
  background: linear-gradient(to right, #3e3d3c, #595858 50%, #3e3d3c);
}

.attract-center {
  width: 15.275rem /* 1222/80 */;
  margin: 0 auto;
  margin-top: 1.3875rem /* 111/80 */;
  display: flex;
  justify-content: space-between;
}

.attract-center > div {
  height: 5.2rem /* 416/80 */;
  background: #000;
  background: url("../../assets/images/frame.png");
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  width: 25%;
}

.attract-center > div > .img {
  display: block;
  width: 2.825rem /* 226/80 */;
  height: 4rem /* 320/80 */;
  margin: 0 auto;
  position: relative;
}

.attract_shadow_img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.45;
}

.img img {
  display: block;
  width: 100%;
  height: 100%;
}

.attract_shadow {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  margin: 0 auto;
  opacity: 0.45;
  width: 100%;
  height: 100%;
  background: url("../../assets/images/frame1.png") no-repeat center;
  background-size: cover;
}

.attract_magnify {
  width: 1.1rem /* 88/80 */;
  height: 1.1rem /* 88/80 */;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  background: url("../../assets/images/magnify.png") no-repeat center;
  background-size: cover;
  z-index: 2;
}
</style>
